import React from 'react';

import { CodeBlock } from '@atlaskit/code';
import type { AuditLogEventData } from '@atlassian/audit-logs-common';

export interface JSONTabPanelProps {
	event?: AuditLogEventData;
	eventJson?: string;
}

export const JSONTabPanel = ({ event, eventJson }: JSONTabPanelProps): React.JSX.Element => {
	const displayJson = React.useMemo(() => {
		if (event?.rawEvent) {
			return JSON.stringify(event.rawEvent, null, 1);
		}
		if (eventJson) {
			try {
				// Parse and re-stringify with formatting to match event.rawEvent style
				return JSON.stringify(JSON.parse(eventJson), null, 1);
			} catch {
				// If parsing fails, return as-is
				return eventJson;
			}
		}
		return '';
	}, [event?.rawEvent, eventJson]);

	return <CodeBlock language="json" text={displayJson} shouldWrapLongLines={true} />;
};
